import { useState, useEffect, useCallback, useRef } from "react";
import "../KeyGen/KeyGen.css";
import axios from "axios";
import FormTermInput from "../KeyGen/Components/FormTermInput/FormTermInput";
import FrequencyTermList from "../KeyGen/Components/FrequencyTermList/FrequencyTermList";
import { bannedWords, fillerWords } from "../../../../../../data/bannedWords";

const TitleGen = (props) => {
  const [termInput, setTermInput] = useState({
    skuOrAsinInput: "",
    headTerm: "",
    titles: "",
  });
  const [finalTermState, setFinalTermState] = useState({
    amazonSuggestedSearch: null,
    secondaries: null, //Top 20 hand picked terms
    //Final Selection char count
    //   const [charCount, setCharCount] = useState(0);

    finalTermsFull: null, //Just need to alter this object to change other final state
  });
  const [showPreview, setShowPreview] = useState(false);
  const termFormRef = useRef();
  const [skuInputStatus, setSkuInputStatus] = useState(null);
  const [isValidSku, setIsValidSku] = useState(false);
  const [skuTermDict, setSkuTermDict] = useState(null);
  const parentChildSkuAssociationRef = useRef();

  const [frequencyBlocks, setFrequencyBlocks] = useState({});

  const resultsRef = useRef();

  const {
    skuOrAsinInput,
    headTerm,
    titles, //Top 20 hand picked terms
  } = termInput;

  //Validate Sku input debounce to allow time to type without searched on every character
  //When the sku validates or not it shows the corresponding valid/invalid icon
  useEffect(() => {
    if (skuOrAsinInput && skuTermDict[skuOrAsinInput]) {
      setIsValidSku(() => true);
      setSkuInputStatus(() => "valid");
    } else if (skuOrAsinInput && !skuTermDict[skuOrAsinInput]) {
      setIsValidSku(() => false);
      setSkuInputStatus(() => "invalid");
    }
  }, [skuOrAsinInput, skuTermDict]);

  //Timer to remove sku input status icon after 3 seconds.
  //Every time sku changed the timer is reset.
  useEffect(() => {
    let removeStatusDebouce;
    if (skuInputStatus) {
      removeStatusDebouce = setTimeout(() => {
        setSkuInputStatus(null);
      }, 3000);
    }
    return () => {
      if (removeStatusDebouce) {
        clearTimeout(removeStatusDebouce);
      }
    };
  }, [skuInputStatus]);

  //Get list of all the skus for inital input
  useEffect(() => {
    axios
      .get("/sku/getSkuTermAssociation")
      .then(({ data }) => {
        parentChildSkuAssociationRef.current = data.parentChildAssociationDict;
        setSkuTermDict(() => data.skuTermDict);
        // setSkuList(() => data.skuList)
      })
      .catch((err) => console.log(err));
  }, []);

  const handleInputChange = (e) => {
    setTermInput((oldState) => ({
      ...oldState,
      [e.target.name]: e.target.value,
    }));
  };

  const sortTermArray = (arr) => {
    return arr.sort(({ term: a }, { term: b }) => a.localeCompare(b));
  };

  const processRawTermText = async () => {
    try {
      //emptySearchBox dictionary to accumulate terms
      let searchBoxTermList = {};

      const combinedTerms = [{ headTerm }, { titles }].reduce((acc, list) => {
        for (let sourceName in list) {
          let tempTermHolder = list[sourceName];

          tempTermHolder = tempTermHolder.replace(/\n/g, " ");

          tempTermHolder = tempTermHolder.split(" ").reduce((dict, term) => {
            //Remove all special characters and hyphens at beginning or ending of the words
            let trimmedTerm = term.replaceAll(/[^a-z0-9]/gi, " ");

            //Trim any remaining white space and lowercase the word
            trimmedTerm = trimmedTerm.trim().toLowerCase();

            for (let subTerm of trimmedTerm.split(" ")) {
              //Counting terms and keeping original term
              if (subTerm) {
                if (!dict[subTerm]) {
                  dict[subTerm] = {
                    count: 1,
                    original: term,
                  };
                } else {
                  dict[subTerm].count++;
                }
              }
            }
            return dict;
          }, {});

          for (let term in tempTermHolder) {
            if (!acc[term]) {
              const banned =
                bannedWords[term] || fillerWords[term] ? true : false;
              acc[term] = {
                original: tempTermHolder[term].original,
                frequency: tempTermHolder[term].count,
                source: sourceName,
                banned,
              };
            } else {
              acc[term].frequency += tempTermHolder[term].count;
            }
          }
        }
        return acc;
      }, {});

      setFinalTermState(() => ({
        amazonSuggestedSearch: searchBoxTermList,
        finalTermsFull: combinedTerms,
      }));
    } catch (err) {
      console.log("WOAH MEGA ERROR!", err);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log(
      "Calculating bi-rotational constants and refactoring tertiary reference points to adhere to the coefficient canonical axis results in the associated percolated article table..."
    );

    //Make sure all required input fields are not empty
    const combinedTerms = [titles].every((list) => list !== "");

    //If all required field are populated, process the terms
    if (combinedTerms) {
      processRawTermText();
    } else {
      alert("NO EMPTY TERM LISTS!");
    }
  };

  const generateFinalTermArray = useCallback(async () => {
    const { finalTermsFull } = finalTermState;

    //Create list for amazonSuggestedSearch terms so they can be displayed separately
    const searchBoxSuggestionArr = [];
    const headTermArr = [];

    let freqLimit2 = [];
    let freqLimit3 = [];
    let freqLimit4 = [];

    //Create array for remaining terms that are not amazonSuggestedSearch
    Object.entries(finalTermsFull).forEach(
      ([key, { frequency, source, banned, original }]) => {
        if (source === "headTerm") {
          headTermArr.push({ term: key, frequency, source, banned, original });
        } else {
          if (frequency >= 2) {
            freqLimit2.push({ term: key, frequency, source, banned, original });
          }
          if (frequency >= 3) {
            freqLimit3.push({ term: key, frequency, source, banned, original });
          }
          if (frequency >= 4) {
            freqLimit4.push({ term: key, frequency, source, banned, original });
          }
        }
      }
    );

    console.log({ finalTermsFull });

    console.log({ headTerm: termInput.headTerm, headTermArr });

    const orderedHeadTerms = termInput.headTerm.split(" ").map((term) => {
      return {
        term,
        frequency: 1,
        banned: bannedWords[term],
      };
    });

    freqLimit2 = [
      ...orderedHeadTerms,
      ...sortTermArray([...searchBoxSuggestionArr, ...freqLimit2]),
    ];
    freqLimit3 = [
      ...orderedHeadTerms,
      ...sortTermArray([...searchBoxSuggestionArr, ...freqLimit3]),
    ];
    freqLimit4 = [
      ...orderedHeadTerms,
      ...sortTermArray([...searchBoxSuggestionArr, ...freqLimit4]),
    ];

    setFrequencyBlocks({
      freqLimit2,
      freqLimit3,
      freqLimit4,
    });
    setShowPreview(true);
  }, [finalTermState, termInput.headTerm]);

  //Scroll to results when the are generated
  useEffect(() => {
    if (showPreview) {
      resultsRef.current.scrollIntoView();
    }
  }, [showPreview]);

  //Regenerate list any time user re-submit input terms
  useEffect(() => {
    const { amazonSuggestedSearch, finalTermsFull } = finalTermState;
    //Check to see if values are in both the amazonSuggestedSearch list and the full list
    if (amazonSuggestedSearch && finalTermsFull) {
      generateFinalTermArray();
    }
  }, [generateFinalTermArray, finalTermState]);

  return (
    <main id="keygen">
      <FormTermInput
        tGen={true}
        handleFormSubmit={handleFormSubmit}
        termFormRef={termFormRef}
        skuOrAsinInput={skuOrAsinInput}
        skuInputStatus={skuInputStatus}
        skuTermDict={skuTermDict}
        handleInputChange={handleInputChange}
        headTerm={headTerm}
        termInput={termInput}
        isValidSku={isValidSku}
        parentChildSkuAssociationRef={parentChildSkuAssociationRef}
      />
      {showPreview ? (
        <>
          <section id="keygen-results-container" ref={resultsRef}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
            >
              <FrequencyTermList
                termList={frequencyBlocks.freqLimit4}
                frequency={4}
              />
              <FrequencyTermList
                termList={frequencyBlocks.freqLimit3}
                frequency={3}
              />
              <FrequencyTermList
                termList={frequencyBlocks.freqLimit2}
                frequency={2}
              />
            </div>
          </section>
        </>
      ) : null}
    </main>
  );
};

export default TitleGen;
